// Filtros
import { dateFilter } from '@/utils/filters';
export default {
    name: 'Form',
    data: () => ({
        reasons: [
            { name: 'Preço', value: 'price' },
            { name: 'Técnico', value: 'technical' },
            {
                name: 'Referências anteriores do fornecedor',
                value: 'reference'
            },
            { name: 'Não sei informar', value: 'dont-know' },
            { name: 'Outro', value: 'other' }
        ],
        messages: [
            {
                name:
                    'Agradecemos a participação, porém optamos por outro fornecedor. Voltaremos a fazer contato numa nova oportunidade',
                value: 'another-supplier'
            },
            {
                name: 'Agradecemos sua participação porém decidimos não realizar a contratação.',
                value: 'technical'
            },
            {
                name:
                    'Agradecemos sua participação porém ainda não sabemos quando realizaremos a contratação. Na ocasião da contratação voltaremos a fazer contato.',
                value: 'schedule'
            },
            { name: 'Outra mensagem', value: 'other' }
        ]
    }),
    filters: {
        date: dateFilter
    },
    props: {
        quotations: Array,
        feedbacks: Array,
        alternativeWinners: Array,
        currentQuotationIndex: Number,
        currentSupplierIndex: Number
    },
    methods: {
        previousQuotation() {
            if (this.currentQuotationIndex === 0) {
                this.$emit('currentQuotationIndex', this.quotations.length - 1);
            } else {
                let currentQuotationIndex = this.currentQuotationIndex;
                this.$emit('currentQuotationIndex', (currentQuotationIndex -= 1));
            }
        },
        nextQuotation() {
            const currentQuotationIndex = this.currentQuotationIndex;
            this.$emit('currentQuotationIndex', (currentQuotationIndex + 1) % this.quotations.length);
        }
    }
};
